module.exports = __webpack_public_path__ + "static/media/hbase.02023665.svg";